(function() {
  function setRecentlyViewedProduct() {
    const track = document.querySelector('[id^="rv-slider-track-"]');
    if (!track) return;

    const currentHandle = track.getAttribute('data-product-handle');
    if (!currentHandle) return;

    let viewedProducts = JSON.parse(localStorage.getItem('recently_viewed_store')) || [];
    viewedProducts = viewedProducts.filter(handle => handle !== currentHandle);
    viewedProducts.unshift(currentHandle);
    
    if (viewedProducts.length > 12) viewedProducts.pop();
    localStorage.setItem('recently_viewed_store', JSON.stringify(viewedProducts));
  }

  function formatCurrency(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '₹ ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' INR';
  }

  function renderRecentlyViewed() {
    const track = document.querySelector('[id^="rv-slider-track-"]');
    if (!track) return;

    const secId = track.id.replace('rv-slider-track-', '');
    const currentHandle = track.getAttribute('data-product-handle');
    const viewedProducts = JSON.parse(localStorage.getItem('recently_viewed_store')) || [];
    
    const filteredProducts = viewedProducts.filter(handle => handle !== currentHandle);

    if (filteredProducts.length === 0) {
      const emptyMsg = document.getElementById(`rv-empty-msg-${secId}`);
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }

    let fetchPromises = filteredProducts.map(handle => 
      fetch(`/products/${handle}.js`)
        .then(res => { if (!res.ok) throw new Error(); return res.json(); })
        .catch(() => null)
    );

    Promise.all(fetchPromises).then(products => {
      const validProducts = products.filter(p => p !== null);
      if (validProducts.length === 0) return;

      validProducts.forEach(product => {
        const price = product.price;
        const comparePrice = product.compare_at_price;
        const hasSale = comparePrice && comparePrice > price;

        const formattedPrice = formatCurrency(price);
        const formattedCompare = hasSale ? formatCurrency(comparePrice) : '';

        const productHtml = `
          <div class="rv-product-card">
            ${hasSale ? '<span class="rv-badge">SALE</span>' : ''}
            <div class="rv-image-container">
              <img src="${product.featured_image}" alt="${encodeURIComponent(product.title)}" class="rv-product-img" loading="lazy">
            </div>
            <div class="rv-product-info">
              <h3 class="rv-product-title">${product.title}</h3>
              <div class="rv-price-container">
                <span class="rv-current-price">${formattedPrice}</span>
                ${hasSale ? `<span class="rv-old-price">${formattedCompare}</span>` : ''}
              </div>
              <form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${product.variants[0].id}" />
                <button type="submit" class="rv-add-to-cart">Add to cart</button>
              </form>
              <a href="${product.url}" class="rv-learn-more">Learn More</a>
            </div>
          </div>
        `;
        track.insertAdjacentHTML('beforeend', productHtml);
      });

      initializeSliderControls(track, secId);
    });
  }

  function initializeSliderControls(track, secId) {
    const nextBtn = document.getElementById(`rv-next-${secId}`);
    const prevBtn = document.getElementById(`rv-prev-${secId}`);
    const wrapper = track.closest('.rv-slider-wrapper');
    if (!nextBtn || !prevBtn || !wrapper) return;

    // EDGE DETECTION MECHANISM: Arrow visibility states updates
    function checkEdgeStates() {
      const scrollLeft = wrapper.scrollLeft;
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

      // Left boundary check
      if (scrollLeft <= 5) {
        prevBtn.classList.remove('is-active');
        prevBtn.classList.add('is-hidden');
      } else {
        prevBtn.classList.remove('is-hidden');
        prevBtn.classList.add('is-active');
      }

      // Right boundary check
      if (scrollLeft >= maxScroll - 5) {
        nextBtn.classList.remove('is-active');
        nextBtn.classList.add('is-hidden');
      } else {
        nextBtn.classList.remove('is-hidden');
        nextBtn.classList.add('is-active');
      }
    }

    // CHUNK PAGE-BY-PAGE CLICK MECHANICS WITH VELOCITY EASING EFFECT
    nextBtn.addEventListener("click", () => {
      const fullPageWidth = wrapper.clientWidth;
      wrapper.scrollBy({ left: fullPageWidth, behavior: 'smooth' });
    });

    prevBtn.addEventListener("click", () => {
      const fullPageWidth = wrapper.clientWidth;
      wrapper.scrollBy({ left: -fullPageWidth, behavior: 'smooth' });
    });

    // Handle scroll positions updates gracefully during manual drag/swipe tracking
    let scrollTimeout;
    wrapper.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(checkEdgeStates, 50); // Eased threshold calculation check
    });

    window.addEventListener('resize', checkEdgeStates);

    // Initial load setup trigger
    setTimeout(checkEdgeStates, 300);
  }

  document.addEventListener("DOMContentLoaded", function () {
    setRecentlyViewedProduct();
    renderRecentlyViewed();
  });
})();